import { useState } from 'react';
import { useUnit } from 'effector-react';
import clsx from 'clsx';
import { $userCardsStore } from '@lib/store/userManagement';
import { FormatUtils } from '@shared/utils';
import type { UsersResponse } from '@shared/api/rest/users';
import { Button, ColorsEnum, Icon, Modal, Text } from '@shared/widgets';
import CrossIcon from '@assets/icons/cross.svg';

interface IRemoveCardsProps {
  show: boolean;
  onClose: () => void;
  userData: UsersResponse;
}

export const RemoveCardsModal = (props: IRemoveCardsProps) => {
  const userCardsStore = useUnit($userCardsStore.store);

  const [selectedCards, setSelectedCards] = useState<number[]>([]);

  const closeHandler = () => {
    setSelectedCards([]);
    props.onClose();
  };
  const confirmRemoveHandler = async () => {
    if (!selectedCards.length) {
      closeHandler();
      return;
    }
    await $userCardsStore.events.deleteCard({ userIds: props.userData.id, cardIds: selectedCards });
    closeHandler();
  };

  return (
    <Modal title='Remove cards' isOpen={props.show} onClose={closeHandler}>
      <div className='flex flex-col items-start'>
        {userCardsStore.data.data.map((card, idx) => (
          <div
            key={idx}
            className={clsx(
              'flex items-center p-2 pl-3 w-max-full mb-2 rounded-sm dark:bg-slate bg-white',
              selectedCards.includes(card.cardId) && 'opacity-50 pointer-events-none',
            )}
          >
            <div className='shrink min-w-0 pr-4'>
              <Text className='text-ellipsis' size='sm'>
                {FormatUtils.toSliceNumber(card.cardNumber, 16)}
              </Text>
              <Text className='text-ellipsis' size='xs' color={ColorsEnum.Gray}>
                {card.cardHolder}
              </Text>
            </div>
            <Button className='flex items-center justify-center w-4 h-4 !p-0' onClick={() => setSelectedCards((prev) => [...prev, card.cardId])}>
              <Icon icon={<CrossIcon />} color='red' />
            </Button>
          </div>
        ))}
      </div>
      <Button className='mt-5' color='primary' fullWidth disabled={userCardsStore.loading} onClick={confirmRemoveHandler}>
        Confirm
      </Button>
    </Modal>
  );
};
